<template>
    <h3 :style="subtitleStyles">{{ config.label }}</h3>
</template>

<script>

    export default{

        name: 'BookingSubtitle',
        props: {
            config: Object
        },
        computed:{
            subtitleStyles: function(){
                return {
                    ...this.config.attributes
                }
            }
        }
    }

</script>

<style>

</style>